module.exports = __webpack_public_path__ + "img/popup-close.620f8f5b.svg";